/**
 * Motion tokens — durations + easing for transitions/animations, matching
 * the 0.1/0.15/0.2/0.3s values already scattered across components.
 */
export const DURATION = {
  instant: '0.1s',
  fast: '0.15s',
  base: '0.2s',
  slow: '0.3s',
} as const;

export const EASING = {
  standard: 'ease',
  out: 'ease-out',
  inOut: 'ease-in-out',
} as const;

export type DurationKey = keyof typeof DURATION;
export type EasingKey = keyof typeof EASING;
